import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faBuilding, faUpload, faImage } from "@fortawesome/free-solid-svg-icons";
import { getEmpresa, actualizarEmpresa, validarRucFactiliza } from "../../../services/empresaservice";
import "./Empresa.css";

// URL BASE donde se guardan las imágenes en el backend
// Ajusta esto a tu ruta real, ej: http://localhost/tu_proyecto/backend/images/
const BASE_IMAGE_URL = "https://jm.komerzy.com/backend/images/"; 

export default function Empresa() {
    const userData = JSON.parse(localStorage.getItem('user'));
    
    const [loading, setLoading] = useState(true);
    const [empresa, setEmpresa] = useState({
        codemp: 0, 
        razonsocial: '',
        ruc: '',
        direccion: '',
        ciudad: '', 
        telefono: '',
        correo: '',
        sitioweb: '', 
        logo: '' 
    });

    const [previewLogo, setPreviewLogo] = useState('');

    useEffect(() => {
        cargarEmpresa();
    }, []);

    const cargarEmpresa = async () => {
        try {
            setLoading(true);
            const data = await getEmpresa();
            
            let datosEmpresa = null;
            if (data && !Array.isArray(data)) { 
                datosEmpresa = data;
            } else if (Array.isArray(data) && data.length > 0) {
                 datosEmpresa = data[0];
            }

            if(datosEmpresa){
                setEmpresa({
                    ...datosEmpresa,
                    correo: datosEmpresa.email || datosEmpresa.correo || '',
                    sitioweb: datosEmpresa.sitioweb || datosEmpresa.website || '' 
                });

                if(datosEmpresa.logo && datosEmpresa.logo.length > 0){
                    setPreviewLogo(`${BASE_IMAGE_URL}${datosEmpresa.logo}`);
                }
            }

        } catch (error) {
            console.error(error);
            toast.error("Error cargando datos de la empresa");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmpresa({ ...empresa, [name]: value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 2 * 1024 * 1024) {
                return toast.warning("La imagen no debe pesar más de 2MB");
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                setEmpresa({ ...empresa, logo: reader.result });
                setPreviewLogo(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleValidarRuc = async () => {
        if (!empresa.ruc || empresa.ruc.length !== 11) {
            return toast.warning("Ingrese un RUC válido de 11 dígitos");
        }

        toast.info("Consultando RUC en SUNAT...", { autoClose: 1500 });

        try {
            const res = await validarRucFactiliza(empresa.ruc);
            
            if (res && res.status === 200 && res.data) {
                const info = res.data;
                
                if (info.estado === "ACTIVO") {
                    setEmpresa(prev => ({
                        ...prev,
                        razonsocial: info.razon_social || prev.razonsocial,
                        direccion: info.direccion || info.direccion_completa || prev.direccion,
                        ciudad: info.distrito || info.provincia || prev.ciudad
                    }));
                    toast.success("RUC válido. Datos autocompletados.");
                } else {
                    toast.warning(`El RUC está en estado: ${info.estado}`);
                }
            } else {
                toast.error(res?.message || "No se encontró el RUC en los registros");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error de conexión al validar");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!empresa.razonsocial || !empresa.ruc) {
            return toast.warning("Razón Social y RUC son obligatorios");
        }

        if (empresa.ruc.length !== 11) {
            return toast.warning("El RUC debe tener exactamente 11 dígitos");
        }

        const datosEnviar = {
            ...empresa,
            logo: (previewLogo && previewLogo.startsWith('data:image')) ? empresa.logo : null, 
            idusuario: userData ? userData.idusuario : 1
        };

        try {
            const res = await actualizarEmpresa(datosEnviar);
            
            if (res && res.res === 1) {
                toast.success("Información actualizada correctamente");
                window.dispatchEvent(new Event("empresaActualizada"));
            } else {
                toast.error(res?.mensaje || "Error al actualizar");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error de conexión");
        }
    };

    if (loading) return <div className="empresa-container">Cargando datos...</div>;

    return (
        <div className="empresa-container">
            <ToastContainer position="top-right" autoClose={2000} />
            
            <div className="empresa-card">
                <div className="empresa-header">
                    <h2><FontAwesomeIcon icon={faBuilding} /> Configuración de Empresa</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-grid">
                        
                        {/* COLUMNA IZQUIERDA: LOGO */}
                        <div className="logo-section">
                            <label>Logotipo</label>
                            <div className="logo-preview">
                                {previewLogo ? (
                                    <img src={previewLogo} alt="Logo Empresa" />
                                ) : (
                                    <div className="logo-placeholder">
                                        <FontAwesomeIcon icon={faImage} size="3x" />
                                        <p>Sin Logo</p>
                                    </div>
                                )}
                            </div>
                            <label htmlFor="logo-upload" className="btn-upload">
                                <FontAwesomeIcon icon={faUpload} /> Subir Imagen
                            </label>
                            <input 
                                id="logo-upload" 
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageChange} 
                                style={{ display: 'none' }}
                            />
                            <small style={{color: '#888', fontSize: '0.8rem'}}>Formatos: PNG, JPG (Máx 2MB)</small>
                        </div>

                        {/* COLUMNA DERECHA: DATOS */}
                        <div className="fields-section">
                            <div className="form-group full-width">
                                <label>Razón Social / Nombre</label>
                                <input 
                                    className="form-input"
                                    name="razonsocial"
                                    value={empresa.razonsocial}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* AQUÍ ESTÁ EL CAMBIO PRINCIPAL: EL BOTÓN DE VALIDAR AL LADO DEL INPUT */}
                            <div className="form-group">
                                <label>RUC / Documento</label>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <input 
                                        className="form-input"
                                        name="ruc"
                                        value={empresa.ruc}
                                        onChange={handleChange}
                                        maxLength={11}
                                    />
                                    <button 
                                        type="button" 
                                        onClick={handleValidarRuc} 
                                        style={{ 
                                            padding: '10px 15px', 
                                            backgroundColor: '#0d6efd', 
                                            color: 'white', 
                                            border: 'none', 
                                            borderRadius: '5px', 
                                            cursor: 'pointer' 
                                        }}
                                    >
                                        Validar
                                    </button>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Teléfono</label>
                                <input 
                                    className="form-input"
                                    name="telefono"
                                    value={empresa.telefono}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label>Ciudad</label>
                                <input 
                                    className="form-input"
                                    name="ciudad"
                                    value={empresa.ciudad}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group full-width">
                                <label>Dirección Fiscal</label>
                                <input 
                                    className="form-input"
                                    name="direccion"
                                    value={empresa.direccion}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label>Correo Electrónico</label>
                                <input 
                                    className="form-input"
                                    type="email"
                                    name="correo"
                                    value={empresa.correo}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label>Sitio Web</label>
                                <input 
                                    className="form-input"
                                    name="sitioweb"
                                    value={empresa.sitioweb}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="submit" className="btn-save">
                            <FontAwesomeIcon icon={faSave} /> Guardar Cambios
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}